export { default } from './TabsWithMedia.js'
export type { TabsWithMediaProps, TabItem, TimeIndex } from './types.js'
